import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { AllowBackOrders, LowStock, PreOrder, RestockDate, Sku, StockAvailability, StockQuantity } from "../../../../../../constants";
import { useAppDispatch } from "../../../../../../reduxToolkit/hooks";
import { setFormValue } from "../../../../../../reduxToolkit/reducers/eCommerce/addProductSlice";
import { LowStockValues, StockStatus } from "../../../../../../data/applications/ECommerce";

// This component handles additional product options, including stock availability, SKU, quantity, and digital product settings.
const Inventory = () => {
  const dispatch = useAppDispatch()

  return (
    <div className="meta-body">
      <Form id="advance-tab">
        <Row className="g-3 custom-input">
          <Col sm="6">
            <Label>{StockAvailability}</Label>
            <Input type="select" name="stock" defaultValue={"In stock"} onChange={(e) => dispatch(setFormValue({ name: "stock", value: e.target.value }))}>
              {StockStatus.map((item, index) => (<option key={index}>{item}</option>))}
            </Input>
          </Col>
          <Col sm="6">
            <Label>{LowStock}</Label>
            <Input type="select" name="lowStock" defaultValue={"Low Stock (5 or less)"} onChange={(e) => dispatch(setFormValue({ name: "lowStock", value: e.target.value }))}>
              {LowStockValues.map((item, index) => (<option key={index}>{item}</option>))}
            </Input>
          </Col>
          <Col lg="3" sm="6">
            <Label>{Sku} <span className="text-danger">*</span></Label>
            <Input type="text" name="sku" onChange={(e) => dispatch(setFormValue({ name: "sku", value: e.target.value }))} />
          </Col>
          <Col lg="3" sm="6">
            <Label>{StockQuantity} <span className="text-danger">*</span></Label>
            <Input type="number" name="quantity" defaultValue={7} min={0} onChange={(e) => dispatch(setFormValue({ name: "quantity", value: e.target.value }))} />
          </Col>
          <Col lg="3" sm="6">
            <Label>{RestockDate} <span className="text-danger">*</span></Label>
            <Input type="number" name="restock" onChange={(e) => dispatch(setFormValue({ name: "restock", value: e.target.value }))} />
          </Col>
          <Col lg="3" sm="6">
            <Label>{PreOrder} <span className="text-danger">*</span></Label>
            <Input type="number" />
          </Col>
          <Col xs="12">
            <Label>{AllowBackOrders}</Label>
            <FormGroup check>
              <Input id="gridCheck" type="checkbox" />
              <Label className="m-0" for="gridCheck" check>This is a digital Product</Label>
              <p className="f-light">Decide if the product is a digital or physical item. Shipping may be necessary for real-world items.</p>
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Inventory;